import * as types from "./loginAction";

export default function(state = [], action) {
  const loginUser = action.user;

  switch (action.type) {
    case types.LOGIN_USER_SUCCESS:
      return { ...state, loginUser };
    case types.LOGIN_FAIL:
      localStorage.clear();
      return { state: undefined };
    case types.LOGOUT:
      localStorage.clear();
      return { state: undefined };

    default:
      return state;
  }
}
